var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5001L3.875 14.3334C2.82305 12.8401 2.35222 11.0143 2.55087 9.19852C2.74952 7.38274 3.60399 5.70188 4.95392 4.47136C6.30386 3.24085 8.05646 2.54527 9.88282 2.51518C11.7092 2.48508 13.4837 3.12254 14.8735 4.30791C16.2632 5.49328 17.1726 7.14508 17.431 8.95332C17.6893 10.7616 17.2789 12.6019 16.2768 14.1291C15.2746 15.6562 13.7495 16.7651 11.9878 17.2477C10.2261 17.7303 8.34885 17.5533 6.70833 16.7501L2.5 17.5001",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.3335C7.5 8.444 7.5439 8.54998 7.62204 8.62812C7.70018 8.70626 7.80616 8.75016 7.91667 8.75016C8.02717 8.75016 8.13315 8.70626 8.21129 8.62812C8.28943 8.54998 8.33333 8.444 8.33333 8.3335V7.50016C8.33333 7.38966 8.28943 7.28367 8.21129 7.20553C8.13315 7.12739 8.02717 7.0835 7.91667 7.0835C7.80616 7.0835 7.70018 7.12739 7.62204 7.20553C7.5439 7.28367 7.5 7.38966 7.5 7.50016V8.3335ZM7.5 8.3335C7.5 9.43856 7.93899 10.4984 8.72039 11.2798C9.50179 12.0612 10.5616 12.5002 11.6667 12.5002M11.6667 12.5002H12.5C12.6105 12.5002 12.7165 12.4563 12.7946 12.3781C12.8728 12.3 12.9167 12.194 12.9167 12.0835C12.9167 11.973 12.8728 11.867 12.7946 11.7889C12.7165 11.7107 12.6105 11.6668 12.5 11.6668H11.6667C11.5562 11.6668 11.4502 11.7107 11.372 11.7889C11.2939 11.867 11.25 11.973 11.25 12.0835C11.25 12.194 11.2939 12.3 11.372 12.3781C11.4502 12.4563 11.5562 12.5002 11.6667 12.5002Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIconWhite);
export default __webpack_public_path__ + "static/media/whatsappIcon-white.bbd9034377950427b99a517d11dd703e.svg";
export { ForwardRef as ReactComponent };